import { render, staticRenderFns } from "./goal.vue?vue&type=template&id=78652be0&scoped=true&"
import script from "./goal.vue?vue&type=script&lang=js&"
export * from "./goal.vue?vue&type=script&lang=js&"
import style0 from "./goal.vue?vue&type=style&index=0&id=78652be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78652be0",
  null
  
)

export default component.exports